import IVenue from "../../interfaces/IVenue";
import { IDialogChildComponent } from "../../reducers/dialog";
import { VenueViewCard } from "../ui/VenueViewCard";


interface IProps extends IDialogChildComponent {
    venueList: IVenue[];
}

export function ReportingVenuesDialog({ venueList }: IProps) {
    return <div>{venueList.map((venue) => {
        return <VenueViewCard
            key={venue?.id}
            venue={venue}
            hideChev={true}
        />
    })}
    </div>
}